export const DEFAULT_PROMO_TERMS = {
  promotionName: "PULA PULA SETTE FIBRA - DA FERIAS PRO SEU BOLSO",
  footerPromotionName: "Pula Pula Sette Fibra",
  termsContent: `## 1. Da campanha

A campanha promocional **"PULA PULA SETTE FIBRA - DA FERIAS PRO SEU BOLSO"**, promovida pela Sette Fibra, tem como objetivo a comercializacao de planos de acesso a internet banda larga, conforme as condicoes descritas neste regulamento.

## 2. Do periodo de vigencia

A campanha tera vigencia de 115 (cento e quinze) dias, iniciando-se em **05 de janeiro de 2026** e encerrando-se em **30 de abril de 2026**, podendo ser encerrada antecipadamente ou prorrogada a criterio exclusivo da Sette Fibra, mediante comunicacao previa.

## 3. Do plano ofertado

O plano promocional ofertado e o Plano 800 Mega Dobradinha Sette Fibra, composto por:

- 400 Mbps + 400 Mbps, totalizando 800 Mbps.

### 3.1 Franquia de dados

O plano possui franquia mensal de 900 GB (novecentos gigabytes). Ao atingir o limite da franquia, a velocidade sera reduzida para 400 Mbps, permanecendo assim ate o inicio de um novo ciclo de faturamento.

## 4. Do valor e condicoes de pagamento

Valor promocional: R$ 89,90 (oitenta e nove reais e noventa centavos), fixo por 12 (doze) meses, ate a data de vencimento escolhida pelo cliente.

O valor promocional ja contempla desconto de pontualidade.

Em caso de pagamento apos a data de vencimento, o valor cobrado sera o valor integral do plano, correspondente a R$ 109,90 (cento e nove reais e noventa centavos).

Apos o termino do periodo promocional de 12 meses, o plano retornara automaticamente ao valor integral de R$ 109,90, salvo novas ofertas vigentes.

## 5. Da primeira mensalidade gratis

Os clientes que aderirem a campanha dentro do periodo de vigencia terao direito a primeira mensalidade gratuita, custeada integralmente pela Sette Fibra.

### 5.1 Funcionamento da primeira mensalidade

A primeira mensalidade sera calculada de forma proporcional entre a data de contratacao e a data de vencimento escolhida pelo cliente, sendo este valor integralmente quitado pela Sette Fibra.

Exemplos ilustrativos:

- Contratacao em 10/01/2026 com vencimento em 20/01/2026: boleto proporcional de 10 dias, pago integralmente pela Sette Fibra.
- Contratacao em 10/01/2026 com vencimento em 25/01/2026: boleto proporcional de 15 dias, pago integralmente pela Sette Fibra.

## 6. Do streaming gratuito

O cliente tera direito a 01 (um) mes de streaming gratuito, a contar da data de ativacao do servico de internet.

### 6.1 Opcoes de streaming

O cliente podera escolher 01 (um) streaming gratuito dentre as opcoes disponiveis na plataforma PlayHub Premium, sendo:

- **Disney+** ou
- **HBO Max.**

E vedada a concessao de mais de um streaming gratuito para o mesmo CPF.

### 6.2 Suspensao e continuidade

O streaming gratuito sera automaticamente suspenso apos o periodo de 01 (um) mes.

Caso o cliente deseje continuar com o streaming apos o periodo de degustacao, devera contratar o servico na modalidade a la carte, passando a pagar o valor vigente a partir da data da contratacao.

## 7. Da elegibilidade

A campanha e valida para:

- Novos clientes, e
- Clientes da base que optarem por upgrade de plano, mediante novo contrato.

### 7.1 Upgrade

Exemplo: cliente com plano de 500 Mega por R$ 79,90 que optar pelo Plano PULA PULA SETTE FIBRA devera realizar um novo contrato, passando a usufruir dos beneficios promocionais, incluindo a primeira mensalidade gratuita.

## 8. Da fidelidade e cancelamento

O contrato possui fidelidade minima de 12 (doze) meses.

O cancelamento antes do prazo contratual estara sujeito as multas e condicoes previstas em contrato, conforme politicas vigentes da Sette Fibra.

Os parametros de cancelamento seguem os padroes normais adotados pela empresa, em conformidade com a legislacao aplicavel.

## 9. Disposicoes gerais

- A campanha e valida enquanto durarem os estoques e dentro do periodo de vigencia.
- A Sette Fibra se reserva o direito de alterar, suspender ou encerrar a campanha a qualquer momento, mediante comunicacao previa, respeitados os direitos adquiridos.
- Este regulamento deve ser interpretado em conjunto com o contrato de prestacao de servicos firmado entre as partes.`,
};

export const PROMO_TERMS_DOC_PATH = {
  collection: "config",
  id: "promoTerms",
};
